import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Table, } from 'semantic-ui-react'
import { pythonApiIp, toCurrency } from '../../../../config/constants'
import * as UiConsts from '../../../../config/UiConstants';


class ViewUraAssess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            assessments: [],
            vat_refund_total:''
        }
    }

    componentDidMount() {
        console.log("gura1 ++++++++++ ViewUraAssess componentDidMount");
        console.log("gura12 this.props.user.email:"+this.props.user.email);
        this.getUraAssess()
    }


    getUraAssess = () => {
        console.log("gura13 ++++++++:getUraAssess");
        console.log("gura14 this.props.user.email:"+this.props.user.email);

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getUraAssess', {
            apiKey: "asdfasdf",
            enteredBy: this.props.user.email
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log("gura15:"+JSON.stringify(response.data,null,3));

                if (response.data.result) {
                    console.log("gura16: assessments:" + JSON.stringify(response.data.assessments, null, 3))
                    this.setState({
                        assessments: response.data.assessments,
                        vat_refund_total: response.data.vat_refund_total
                    })

                } else {
                    console.log("gura16 FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    render() {

        const rows = this.state.assessments.length > 0
            ? this.state.assessments.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.idura_assesments} </Table.Cell>
                    <Table.Cell> {item.custom_ref} </Table.Cell>
                    <Table.Cell> {item.decl_ref} </Table.Cell>
                    <Table.Cell> {toCurrency(item.vat_asses)} </Table.Cell>
                    <Table.Cell> {item.asses_ref} </Table.Cell>
                    {/* <Table.Cell> {toCurrency(item.import_duty)} </Table.Cell> */}
                    {/* <Table.Cell> {toCurrency(item.withldng_tax)} </Table.Cell> */}
                    {/* <Table.Cell> {toCurrency(item.inf_levy)} </Table.Cell> */}
                    <Table.Cell> {toCurrency(item.total_taxes)} </Table.Cell>
                    <Table.Cell> {item.prn_code} </Table.Cell>
                    <Table.Cell> {item.printed_on} </Table.Cell>
                    <Table.Cell> <a href={item.assdoclink} target="_blank">VIEW</a></Table.Cell>
                    <Table.Cell> {item.itemtype} </Table.Cell>
                </Table.Row>)
            : ''

        const vat_refund_totalUI = this.state.vat_refund_total != ''
        ? <h2>TOTAL OWED:{toCurrency(this.state.vat_refund_total)}</h2>
        :''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <h2>URA ASSESSMENTS</h2>
                {vat_refund_totalUI}
                {/* <h3> TOTAL COST:{toCurrency(this.state.totalCost)}</h3> */}
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                        <Table.Cell>Item Id</Table.Cell>
                            <Table.Cell>custom_ref</Table.Cell>
                            <Table.Cell>decl_ref</Table.Cell>
                            <Table.Cell positive>vat_asses</Table.Cell>
                            <Table.Cell>asses_ref</Table.Cell>
                            {/* <Table.HeaderCell>import_duty</Table.HeaderCell> */}
                            {/* <Table.HeaderCell>withldng_tax</Table.HeaderCell> */}
                            {/* <Table.HeaderCell>inf_levy</Table.HeaderCell> */}
                            <Table.Cell>total_taxes</Table.Cell>
                            <Table.Cell>prn_code</Table.Cell>
                            <Table.Cell>printed_on</Table.Cell>
                            <Table.Cell>VIEW ASSESS</Table.Cell>
                            <Table.Cell>itemtype</Table.Cell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {rows}
                    </Table.Body>

                </Table>

            </div>
        );
    }
}

export default ViewUraAssess;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ura/ViewUraAssess.js